import {NgModule} from '@angular/core';
import {LuxonTimePipe, LuxonTimePipeU} from './luxon-time.pipe';
import {LuxonPipe, LuxonPipeU} from './luxon.pipe';

@NgModule({
  declarations: [LuxonPipe, LuxonPipeU, LuxonTimePipe, LuxonTimePipeU],
  exports: [LuxonPipe, LuxonPipeU, LuxonTimePipe, LuxonTimePipeU],
})
export class LuxonPipeModule {}
